<div class="frame">
  <div class="title">
    {{character.name}} - メモ
  </div>
  <textarea class="inner-note" name="textArea" placeholder="本文" [(ngModel)]="note"></textarea>
</div>
